/**
 * OMNI 预览 token 的 URL 参数名称和 localStorage key
 */
export const OMNI_PREVIEW_TOKEN_KEY = 'omni_preview_token'

/**
 * 预览水印已绘制状态的 window 对象键名
 */
export const WATERMARK_DRAWN_KEY = '__FL_PREVIEW_WATERMARK_DRAWN__'

/**
 * 预览过期提醒已弹出状态的 window 对象键名
 */
export const FAIL_ALERTED_KEY = '__FL_PREVIEW_FAIL_ALERTED__'
